<div class="userlist-theme userlist-container">

  <div class="page-header">
    <h1 class="ul-heading page-title">Administración de usuarios</h1>
    <div class="page-header-actions">
      <!-- El wrapper recibe el hover: Bootstrap pone pointer-events: none en .btn:disabled -->
      <span class="ul-tooltip-wrapper">
        <button type="button" class="btn header-btn btn-descargar" [disabled]="store.exportando() || store.cargando() || sinResultados"
                [attr.aria-describedby]="sinResultados ? 'tooltipDescargar' : null" (click)="store.exportar()">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12"/><path d="M7 10l5 5 5-5"/><path d="M5 21h14"/></svg>
          {{ store.exportando() ? 'Generando...' : 'Descargar' }}
        </button>
        @if (sinResultados) {
          <span id="tooltipDescargar" class="ul-tooltip" role="tooltip">No hay resultados para exportar</span>
        }
      </span>
      <button type="button" class="btn header-btn btn-logout" (click)="logout()">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="M16 17l5-5-5-5"/><path d="M21 12H9"/></svg>
        Cerrar sesión
      </button>
    </div>
  </div>

  <!-- Stat cards -->
  <div class="ul-stat-row d-flex gap-3 mb-3">
    <div class="ul-stat-card ul-stat-total">
      <div class="ul-stat-label">Total de usuarios</div>
      <div class="ul-stat-value">{{ store.datos().totalCount }}</div>
    </div>
    <div class="ul-stat-card ul-stat-verified">
      <div class="ul-stat-label">Verificados</div>
      <div class="ul-stat-value">{{ store.datos().verifiedCount }}</div>
    </div>
    <div class="ul-stat-card ul-stat-unverified">
      <div class="ul-stat-label">No verificados</div>
      <div class="ul-stat-value">{{ store.datos().unverifiedCount }}</div>
    </div>
  </div>

  <!-- Tabs de filtro -->
  <div class="ul-tabs">
    @for (tab of filterTabs; track tab.value) {
      <button type="button" class="ul-tab" [class.active]="store.filtros().filter === tab.value" (click)="store.cambiarFiltro(tab.value)">
        {{ tab.label }}
      </button>
    }
  </div>

  <!-- Búsqueda por DNI / Email (se dispara solo con "Buscar") -->
  <form class="ul-search" [formGroup]="busquedaForm" (ngSubmit)="buscar()" novalidate>
    <div class="ul-search-field">
      <label for="busquedaDni" class="form-label">DNI</label>
      <div class="position-relative">
        <input id="busquedaDni" type="text" inputmode="numeric" maxlength="9" autocomplete="off"
               class="form-control" [class.is-invalid]="esInvalido('dni') || mostrarErrorCaracterDni" formControlName="dni"
               placeholder="Ej: 30123456"
               (focus)="onFocusDni()" (click)="onFocusDni()" (blur)="onBlurDni()" (input)="mostrarHintDni = false"
               (beforeinput)="onAntesDeEscribirDni($event)" (paste)="onPegarDni($event)">
        @if (mostrarHintDni) {
          <div class="ul-hint" role="tooltip">Indicar DNI sin punto</div>
        }
        @if (mostrarErrorCaracterDni || esInvalido('dni')) {
          <div class="invalid-feedback">Ingresá solo números, sin puntos, entre 7 y 9 dígitos.</div>
        }
      </div>
    </div>

    <div class="ul-search-field">
      <label for="busquedaEmail" class="form-label">Email</label>
      <input id="busquedaEmail" type="text" autocomplete="off"
             class="form-control" [class.is-invalid]="esInvalido('email')" formControlName="email"
             placeholder="usuario@dominio.com">
      @if (esInvalido('email')) {
        <div class="invalid-feedback">Ingresá un email válido (usuario&#64;dominio.com).</div>
      }
    </div>

    <div class="ul-search-actions">
      <button type="submit" class="btn header-btn btn-buscar" [disabled]="store.cargando()">Buscar</button>
      <button type="button" class="btn header-btn btn-limpiar" (click)="limpiarFiltros()">Limpiar filtros</button>
    </div>
  </form>

  @if (store.filtros().dni || store.filtros().email) {
    <div class="ul-applied">
      <span class="ul-applied-label">Filtros aplicados:</span>
      @if (store.filtros().dni) { <span class="ul-chip">DNI: {{ store.filtros().dni }}</span> }
      @if (store.filtros().email) { <span class="ul-chip">Email: {{ store.filtros().email }}</span> }
    </div>
  }

  <!-- Tabla -->
  <div class="table-responsive">
    <table class="table table-hover align-middle users-table">
      <thead>
        <tr>
          <th>Documento</th>
          <th>Nombre</th>
          <th>Apellido</th>
          <th>Email</th>
          <th>Teléfono</th>
          <th>Estado</th>
          <th>Fecha de creación</th>
        </tr>
      </thead>
      <tbody>
        @if (store.cargando()) {
          <tr><td colspan="7" class="text-center text-muted py-4">Cargando...</td></tr>
        } @else {
          @for (user of store.datos().users; track user.nroDocumento) {
            <tr>
              <td>{{ user.tipoDocumento }} {{ user.nroDocumento }}</td>
              <td>{{ user.nombre }}</td>
              <td>{{ user.apellido }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.telefono }}</td>
              <td>
                <span class="badge" [class.badge-ul-positiva]="user.verificado" [class.badge-ul-negativa]="!user.verificado">
                  {{ user.verificado ? 'Verificado' : 'No verificado' }}
                </span>
              </td>
              <td>{{ user.fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}</td>
            </tr>
          } @empty {
            <tr><td colspan="7" class="text-center text-muted py-4">
              @if (store.filtros().dni || store.filtros().email) {
                No se encontraron coincidencias para la búsqueda realizada.
              } @else {
                No se encontraron usuarios para el filtro seleccionado.
              }
            </td></tr>
          }
        }
      </tbody>
    </table>

    <!-- Paginado (contrato page/size/totalPages del backend actual, no hayMas) -->
    <div class="pagination-bar">
      <div class="page-size-selector">
        <label for="pageSize" class="form-label mb-0">Tamaño de página</label>
        <select id="pageSize" class="form-select page-size-select" (change)="onCambiarTamanoPagina($any($event.target).value)">
          @for (option of pageSizeOptions; track option) {
            <option [value]="option" [selected]="option === store.filtros().size">{{ option }}</option>
          }
        </select>
      </div>

      <div class="d-flex align-items-center gap-2">
        <button type="button" class="ul-pg-btn" [disabled]="store.filtros().page === 0" (click)="previousPage()">‹ Anterior</button>
        <span class="ul-pg-indicator">Página {{ store.datos().totalPages === 0 ? 0 : store.filtros().page + 1 }} de {{ store.datos().totalPages }}</span>
        <button type="button" class="ul-pg-btn" [disabled]="store.filtros().page >= store.datos().totalPages - 1" (click)="nextPage()">Siguiente ›</button>
      </div>
    </div>
  </div>

</div>
